export class I18n {
    language = 'ru';
}
